import type { IWatermarkElement } from '@/types/watermarks.types';
import { niceTime } from '@/utils/dates';
import { useState, useRef, useEffect } from 'react';
import styles from '../watermark.module.css';

const currentTime = () => niceTime(Date.now());

const TimeEl = (el: IWatermarkElement) => {
  const [dateStr, setDateStr] = useState(currentTime());
  const interval = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    interval.current = setInterval(() => {
      setDateStr(currentTime());
    }, 60000); // check the date each minute

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);

  return (
    <div
      style={{
        userSelect: 'none',
        fontFamily: `'${el.settings.text.font.name}'`,
        fontSize: el.settings.text.font_size,
        color: el.settings.text.color,
      }}
      className={el.settings.duration === 'pulse' ? styles.pulse : ''}
    >
      {dateStr}
    </div>
  );
};

export default TimeEl;
